import { useMutation, useQuery, useQueryClient } from 'react-query'
import { createResourcesRecord, getResourcesRecordsRegistrations, getResourcesRecordsIndex, updateResourcesRecord } from '../../api/resources'

export function useCreateResourcesRecordMutation(onSuccess) {
  const options = { onSuccess }
  const mutationFunction = formData => createResourcesRecord(formData)

  return useMutation(mutationFunction, options)
}

export function useResourcesRecordsOverviewQuery(jobNumber) {
  return useQuery(['resources_records_overview', jobNumber.id], () => getResourcesRecordsRegistrations({ jobnumber_id: jobNumber.id }))
}

export function useResourcesRecordsIndexQuery(date: string) {
  return useQuery(['resources_records_index', date], () => getResourcesRecordsIndex(date), {
    enabled: !!date,
  })
}

export function useUpdateResourcesRecordMutation(onSuccess?: () => void) {
  const queryClient = useQueryClient()
  
  return useMutation(
    ({ id, payload }: { id: number; payload: object }) => updateResourcesRecord(id, payload),
    {
      onSuccess: () => {
        // Invalidate all resources_records_index queries to refetch data
        queryClient.invalidateQueries('resources_records_index')
        if (onSuccess) {
          onSuccess()
        }
      },
    }
  )
}
